import React, { useState } from 'react';
import ReactLoading from 'react-loading';

import { OwnerTag, PersonTag, CustomerTag, DateTag } from './Tags';

export const Loader = () => {
    return (
        <div className='d-flex justify-content-center align-items-center w-100'>
            <ReactLoading type={'bars'} color={'#262f3d'} height={40} width={40} />
        </div>
    );
};

export const IncompleteActivities = ({ activities, activeItem, hasCustomer = false }) => {
    const [activityDate] = useState(new Date(2020, 9, 20, 11, 45));

    return (
        <>
            {activities.map((activity) => {
                return (
                    <div key={activity.id} className='mb-3 ml-auto' style={{ width: '90%' }}>
                        <div className='d-flex flex-column card p-3'>
                            <div className='d-flex flex-row mb-1'>
                                <div className='d-flex flex-row  my-auto mr-auto'>
                                    <CustomRadioButton id={activity.id + 'radio-button'} />
                                    <h4 className='my-auto'>This is the Title</h4>
                                </div>
                                <button
                                    className='btn btn-light ml-auto my-auto mr-1 d-flex justify-content-center align-items-center'
                                    style={{ width: 25, height: 25, borderRadius: '25%' }}>
                                    <span className='oi oi-ellipses'></span>
                                </button>
                            </div>
                            <div className='d-flex flex-row mb-1'>
                                <DateTag isColorActive={true} itemDate={activityDate} />
                                <p className='d-flex justify-content-center align-items-center my-auto mr-2'>*</p>
                                <OwnerTag activeItem={activeItem.owner} />
                                <PersonTag content='Placeholder...' />
                                {hasCustomer ? <CustomerTag item={activeItem.customer} /> : null}
                            </div>
                        </div>
                        {activity.notes.map((note) => {
                            return (
                                <div key={note.id} className='card bg-yellow p-2'>
                                    <p className='mb-0'>{note.description}</p>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </>
    );
};

const CustomRadioButton = ({ id }) => {
    const [isChecked, setIsChecked] = useState(false);
    return <input id={id} type='radio' className='mr-2 my-auto' checked={isChecked} onClick={() => setIsChecked(!isChecked)} />;
};
